module.exports = __webpack_public_path__ + "img/17.7201a0f8.jpg";